<template>
  <v-card
    v-bind="$attrs"
    v-on="$listeners"
    class="mb-3"
  >
    <!-- Title -->
    <v-card-title
      v-if="hasPrimaryTitle"
      :class="cardTitleClasses"
    >
      <span
        v-if="title"
        v-text="title"
        class="title"
      />
      <v-spacer />
      <slot name="title-actions" />
    </v-card-title>

    <!-- Image -->
    <div
      v-if="src"
      :class="contain ? 'pa-3' : ''"
    >
      <v-img
        :contain="contain"
        :src="src"
        :height="imgHeight"
      />
    </div>


    <v-card-title
      v-if="subTitle"
      primary-title
      class="wrap pb-0"
    >
      <span
        v-if="subTitle"
        class="title secondary--text"
        v-text="subTitle"
      />
      <v-flex
        v-if="caption"
        v-text="caption"
        xs12
        body-1
        grey--text
        pa-0
      />
    </v-card-title>

    <!-- Content -->
    <slot />

    <!-- Actions -->
    <v-card-actions v-if="$slots.actions">
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    inheritAttrs: false,

    props: {
      contain: Boolean,
      imgHeight: {
        type: [Number, String],
        default: 300
      },
      src: String,
      subTitle: String,
      caption: String,
      title: String,
      titleColor: String
    },

    computed: {
      cardTitleClasses () {
        const classes = {
          'white--text': this.hasWhiteText
        }

        if (this.titleColor) classes[this.titleColor] = true

        return classes
      },
      hasPrimaryTitle () {
        return (
          (this.title ||
          this.$slots['title-actions'])
        )
      },
      hasWhiteText () {
        return ['primary', 'secondary'].includes(this.titleColor)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/core/Card.vue